<template>
  <div class="container" >
    <img class="logo" src="/static/img/KovoHome_text_white.svg" alt="Logo" />
    <div class="loginContainer cardBackground">
      <h1>Welcome to Kovo Home</h1>

      <h3>🎉 Registration Complete</h3>
      <p>Thank you for registering with Kovo Home. Your account has been successfully created, and your subscription is now active.</p>

      <h3>📬 Check Your Email</h3>
      <p>We've sent you an email with important details about your subscription, including payment confirmation, your plan summary, and next steps.</p>

      <h3>💡 What’s Next</h3>
      <p>Your Kovo Home firewall device will be shipped shortly if your plan includes hardware. You’ll receive a tracking number as soon as it’s available.</p>

      <h3>🔐 Managing Your Account</h3>
      <p>You can log in to your dashboard to view or update your subscription, change your payment method, or contact support at any time.</p>

      <h3>🙏 Thank You</h3>
      <p>We appreciate your trust in Kovo Home. We're committed to providing you with secure and reliable internet protection for the long term.</p>

      <el-button type="primary" @click="$router.push({ name:'login' })">
        Go to Login
      </el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FinishRegistration',
  computed: {
    // pull the passed-in object
    info() {
      return this.$route.params.regInfo || {}
    },
    plan() {
      const items = this.info.subscription?.subscription?.items
      return items && items.length ? items[0].plan : {}
    }
  },
  methods: {
    formatDate(epochSeconds) {
      if (!epochSeconds) return '—'
      const d = new Date(epochSeconds * 1000)
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
    },
    formatAmount(cents) {
      return (cents/100).toFixed(2)
    },
    async goToHome(){
      this.$router.push({
        name: 'dashboard'
      })
    },
    async goToLogin(){
      this.$router.push({
        name: 'login'
      })
    },

  },
}
</script>

<style >
.mx-auto { margin-left:auto; margin-right:auto; }
.colorSwap{
  color: var(--text-primary) !important;
  background-color: transparent !important;
}
.rightCaret{
  color: white;
  width: 12px;
  height: 21px;
}
.otherWrapper{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
}
.logo{
  width: 80%;
  max-height:120px;
  margin: 0 auto;
  padding: 20px;
}
.loginContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  border-radius: 12px;
  padding: 20px;
}
.emailContainer{
  width: 100%;
}
h2 {
  color:black;
}

</style>
